import { render, staticRenderFns } from "./TkPay.vue?vue&type=template&id=0578db13&scoped=true&"
import script from "./TkPay.vue?vue&type=script&lang=js&"
export * from "./TkPay.vue?vue&type=script&lang=js&"
import style0 from "./TkPay.vue?vue&type=style&index=0&id=0578db13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578db13",
  null
  
)

export default component.exports